import { ParsedUrlQuery } from 'querystring';

enum EstateDetailsFeature {
  STATIC_MAP = 'STATIC_MAP',
}

export class EstateDetailsFeatures {
  constructor(private readonly features: EstateDetailsFeature[]) {}

  shouldShowMap(): boolean {
    return this.features.includes(EstateDetailsFeature.STATIC_MAP);
  }

  static from(q: ParsedUrlQuery): EstateDetailsFeatures {
    const unsafeFeatures = EstateDetailsFeatures.parseQueryString(q);

    const safeFeatures = unsafeFeatures
      .map((unsafeValue) => EstateDetailsFeature[unsafeValue])
      .filter((unsafeValue) => unsafeValue !== undefined);

    return new EstateDetailsFeatures(safeFeatures);
  }

  private static parseQueryString(q: ParsedUrlQuery): string[] {
    const unsafeValue = q['features'];
    if (unsafeValue === undefined) {
      return [];
    }
    if (typeof unsafeValue === 'string') {
      return [unsafeValue];
    }
    return unsafeValue;
  }
}

export const constants = {
  ESTATE_APPLICATION_ACTIONS_COUNTRIES: ['CO'],
};
